import { render } from "./AboutHospital.vue?vue&type=template&id=70eba40e&scoped=true"
import script from "./AboutHospital.vue?vue&type=script&lang=js"
export * from "./AboutHospital.vue?vue&type=script&lang=js"

import "./AboutHospital.vue?vue&type=style&index=0&id=70eba40e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70eba40e"]])

export default __exports__